import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /**
   * Value to display.
   */
  value?: unknown;
  /**
   * Text label that should accompany the displayed value.
   */
  label: string;
}


declare module 'vue/types/vue' {
  export interface Vue {
    DisplayValueText: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'DisplayValueText' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    label: null
  },
  setup(__props: any) {

/**
 * `DisplayValueText` component properties.
 */


return { __sfc: true, }
}

})